module.exports = __webpack_public_path__ + "img/采集过程@2x.4fc4ae0e.png";